import { Injector } from '@angular/core';
import { ItemModel } from '../../../../models/itemModel';
import { FrameItem } from '../../../../models/session';
import { MarioComponent } from '../../mario/mario.component';
import { CollaborativeApps } from '../../iframe/additional-apps.utils';
import { BoardMarioConfigurations } from './board-mario-configurations';
import { BoardApp } from './board-web-viewer';
import { FabricControls } from './board.item';
import { CreationContext } from './board-item-configurations';

export class BoardMario extends BoardApp<BoardMarioConfigurations> {
  AngularComponentClass = MarioComponent;

  constructor(
    injector: Injector,
    configurations: BoardMarioConfigurations,
    creationContext: CreationContext,
  ) {
    super(injector, ItemModel.Mario, configurations, creationContext);

    if (!this.isResizeableApp()) {
      // those apps shouldn't be scalable
      this.hasControls = false;
    }
  }

  public toFrameItem(): FrameItem {
    return {
      ...super.toFrameItem(),
      model: ItemModel.Mario,
      mario_state: {
        id: this.configurations.marioId,
        ownerId: this.configurations.ownerId,
        resource: this.configurations.resource,
        appInstanceId: this.configurations.appInstanceId,
      },
      isPrivate: this.configurations.isPrivate,
      interactionsLocked: this.configurations.interactionsLocked,
    };
  }

  override openLock() {
    if (this.isResizeableApp()) {
      super.openLock();
      return;
    }

    this.lockMovementX = false;
    this.lockMovementY = false;
    this.lockRotation = true;

    this.lockScalingX = true;
    this.lockScalingY = true;

    this.lockUniScaling = false;
    this.lockSkewingX = true;
    this.lockSkewingY = true;
    this.lockScalingFlip = true;
  }

  override setUpControlsVisibility(invisibleControls) {
    if (this.isResizeableApp()) {
      super.setUpControlsVisibility(invisibleControls);
      return;
    }

    for (const control of Object.values(FabricControls)) {
      this.setControlVisible(control, false);
    }
    this.canvas?.requestRenderAll();
  }

  private isResizeableApp() {
    return ![CollaborativeApps.STOPWATCH, CollaborativeApps.TIMER].includes(
      this.configurations.appInstanceId,
    );
  }
}
